import { createTheme, Switch, SwitchProps, ThemeProvider } from '@mui/material'

interface Props extends SwitchProps {
    className?: string
}
const CustomSwitch = ({ className, ...restOfProps }: Props) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#434a73',
            },
        },
    })

    return (
        <ThemeProvider theme={theme}>
            <Switch
                className={className}
                {...restOfProps}
            />
        </ThemeProvider>
    )
}

export default CustomSwitch
